import Environment from '../../Environment';

interface EnhancedProfilesLinkProps {
  cocode: number;
  year: number;
}

export default function EnhancedProfilesLink({ cocode, year }: EnhancedProfilesLinkProps) {
  return (
    <a
      href={`${Environment.APP_URL()}?cocode=${cocode}&year=${year}`}
      target="_blank"
      rel="noreferrer">
      {cocode}
    </a>
  );
}
